import React, { FC, memo, useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Button } from 'shared/ui/Button';

export const AppErrorPage: FC = memo(() => {
  const error = useRouteError();

  const { t } = useAppTranslation('common');

  useEffect(() => {
    console.error(error);
  }, [error]);

  const reloadPage = (): void => {
    window.location.reload();
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center px-4">
      <div className="text-2xl font-semibold text-center mb-2">{t('Something went wrong')}</div>
      <div className="text-primaryLight text-center mb-6">{t('Please reload the page and try again')}</div>
      <Button onClick={reloadPage}>{t('Reload page')}</Button>
    </div>
  );
});
